export default __webpack_public_path__ + "static/media/sETH.d791d7da.svg";